import '../../../GenericContent/CardBlock/CardBlock.scss';

import { createApp, defineAsyncComponent } from 'vue';
import ContentCardCarouselBlock from './ContentCardCarouselBlock.vue';

const CardBlockVideo = defineAsyncComponent(
	() => import('../../../GenericContent/CardBlock/CardBlockVideo.vue'),
);

const contentCardCarouselBlockElems = document.querySelectorAll(
	'[data-feature="content-card-carousel-block"]',
);

if (contentCardCarouselBlockElems) {
	contentCardCarouselBlockElems.forEach((contentCardCarouselBlockElem) => {
		const app = createApp({
			name: 'ContentCardCarouselBlockApp',
		});
		app.component('content-card-carousel-block', ContentCardCarouselBlock);
		app.component('card-block-video', CardBlockVideo);
		app.mount(contentCardCarouselBlockElem);
	});
}

